import { createSelector } from 'reselect';

const makeId = event => (event.account_event ? 'user' : event.subject_id);

/**
* Селектор количества непрочитанных событий по id
* Вместо id залогиненого пользователя - 'user'
*/
const unreadEventsCountById = createSelector(
  state => state.events.unread.events,
  events => events.reduce((ret, event) => {
    ret[makeId(event)] = (ret[makeId(event)] || 0) + 1; // eslint-disable-line no-param-reassign
    return ret;
  }, {})
);

export default unreadEventsCountById;
